import { createSlice, SliceCaseReducers } from "@reduxjs/toolkit";
import { RootState } from "../store";

interface IPersistedSignInAuthState{
    verificationSent: boolean
    confirmationObject: {[key:string]:any} | null
}

const persistedSignInAuth = createSlice<IPersistedSignInAuthState, SliceCaseReducers<IPersistedSignInAuthState>>({
    name: "persistedSignInAuth",
    initialState:{
        verificationSent: false,
        confirmationObject : null
    },
    reducers:{
        setVerificationSent: (state, action)=>{
            state.verificationSent = action.payload
        },
        setConfirmationObject: (state, action)=>{
            state.confirmationObject = action.payload
        }
    }
})

export const persistedSignInAuthActions = persistedSignInAuth.actions
export const selectVerificationSent = (state:RootState)=>state.persistedSignInAuth.verificationSent
export const selectConfirmationObject = (state:RootState)=>state.persistedSignInAuth.confirmationObject
export default persistedSignInAuth.reducer